export default __webpack_public_path__ + "static/media/topic900_bg2.7c116a64.png";